import React from 'react';
import { useContent } from '../../hooks/useContent';

// Ícone de seta (ChevronRight)
const ChevronRightIcon = ({ className }: { className?: string }) => (
  <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
  </svg>
);

export const HowItWorksSection: React.FC = () => {
  const { content } = useContent();
  
  if (!content?.howItWorks) return null;

  const steps = [
    {
      number: 1,
      title: "Preencha o Formulário",
      description: "Nos conte sobre sua ideia e necessidades.",
      bgColor: "bg-teal-400"
    },
    {
      number: 2,
      title: "Receba a Proposta",
      description: "Nossa equipe de especialistas irá analisar e elaborar uma proposta completa, sem burocracia.",
      bgColor: "bg-sky-500"
    },
    {
      number: 3,
      title: "Comece a Desenvolver",
      description: "Iniciamos o projeto com total transparência e comunicação direta.",
      bgColor: "bg-yellow-400"
    }
  ];

  return (
    <section className="py-20 bg-slate-950">
      <div className="container mx-auto px-6 text-center">
        <h2 className="text-4xl font-bold mb-4 text-white">
          {content.howItWorks.title}
        </h2>
        <p className="text-xl text-gray-400 mb-12 max-w-3xl mx-auto">
          {content.howItWorks.subtitle}
        </p>
        <div className="flex flex-col md:flex-row justify-center items-center gap-12">
          {steps.map((step, index) => (
            <React.Fragment key={step.number}>
              {/* Step */}
              <div className="flex flex-col items-center">
                <div className={`w-16 h-16 flex items-center justify-center ${step.bgColor} rounded-full text-black font-bold text-3xl mb-4 shadow-lg`}>
                  {step.number}
                </div>
                <h3 className="text-xl font-semibold mb-2 text-white">{step.title}</h3>
                <p className="text-gray-400 max-w-xs">
                  {step.description}
                </p>
              </div>
              
              {/* Arrow (only between steps, not after the last one) */}
              {index < steps.length - 1 && (
                <>
                  <ChevronRightIcon className="w-8 h-8 text-slate-600 hidden md:block" />
                  <div className="w-px h-16 bg-slate-600 md:hidden"></div>
                </>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </section>
  );
};